import React from 'react';
import { useMobileContext } from '../../contexts/MobileContext';
import PageShell from '../Layout/PageShell';
import SubPageHero from './SubPageHero';

import ScrollFadeWrapper from '../ScrollFadeWrapper/ScrollFadeWrapper';
import QuoteCarouselComponent from '../HomePage/QuoteCarousel/QuoteCarouselComponent';

import KeyPointAlongSideComponent from '../HomePage/KeyPointAlongSide/KeyPointAlongSideComponent';
import KeyPointAlongSideMobileComponent from '../HomePage/KeyPointAlongSide/KeyPointAlongSideMobileComponent';
import keyPointAlongSideData from '../../json/components/HomePages/DebtCounselling/keyPointAlongSideData.json';

import PartnerBrandsComponent from '../../components/HomePage/PartnerBrands/PartnerBrandsComponent';
import PartnerBrandsMobileComponent from '../../components/HomePage/PartnerBrands/PartnerBrandsMobileComponent';
import partnerBrandsData from '../../json/components/HomePages/DebtCounselling/partnerBrandsData.json';

import FourBlogCardsComponent from '../../components/HomePage/FourBlogCards/FourBlogCardsComponent';
import FourBlogCardsMobileComponent from '../../components/HomePage/FourBlogCards/FourBlogCardsMobileComponent';
import fourBlogCardsData from '../../json/components/HomePages/DebtCounselling/fourBlogCardsData.json';

import CustomerReviewsComponent from '../../components/HomePage/CustomerReviews/CustomerReviewsComponent';
import CustomerReviewsMobileComponent from '../../components/HomePage/CustomerReviews/CustomerReviewsMobileComponent';
import customerReviewsData from '../../json/components/HomePages/DebtCounselling/customerReviewsData.json';

import AccordionFAQComponent from '../../components/HomePage/AccordionFAQ/AccordionFAQComponent';
import AccordionFAQMobileComponent from '../../components/HomePage/AccordionFAQ/AccordionFAQMobileComponent';
import accordionFAQData from '../../json/components/HomePages/DebtCounselling/accordionFAQData.json';

import ScrollingCardsComponent from '../../components/HomePage/ScrollingCards/ScrollingCardsComponent';
import ScrollingCardsMobileComponent from '../../components/HomePage/ScrollingCards/ScrollingCardsMobileComponent';
import scrollingCardsDataAll from '../../json/components/HomePages/DebtCounselling/scrollingCardsAllData.json';

import HippoGenericMobileComponent from '../../components/Banners/HippoGenericMobileComponent';
import HippoTwoLineGenericComponent from '../../components/Banners/HippoTwoLineGenericComponent';

function DebtCounsellingPage({ pathName, heroGateKey, onHeroImageLoad }) {
  const isMobile = useMobileContext();
  const questionRoute = '/debt-counselling/step1';

  return (
    <PageShell gap={{ xs: '24px', sm: '48px', md: '64px' }}>
      <SubPageHero
        pathName={pathName}
        heroGateKey={heroGateKey}
        onImageLoad={onHeroImageLoad}
      />

      <QuoteCarouselComponent
        crossSellKey="latestDebtCounsellingQuotes_CrossSell"
        fallbackKey="latestDebtCounsellingQuotes"
        navigateTo="/debt-counselling/step1"
      />

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <PartnerBrandsComponent data={partnerBrandsData} />
        ) : (
          <PartnerBrandsMobileComponent data={partnerBrandsData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <KeyPointAlongSideComponent data={keyPointAlongSideData} />
        ) : (
          <KeyPointAlongSideMobileComponent data={keyPointAlongSideData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <CustomerReviewsComponent data={customerReviewsData} />
        ) : (
          <CustomerReviewsMobileComponent data={customerReviewsData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <HippoTwoLineGenericComponent
            route={questionRoute}
            image={'HippoHandsDown'}
            title={'Love your money, love some savings'}
            buttonColor={'green'}
            color={'blue'}
            buttonText={'View banking fees guide'}
          />
        ) : (
          <HippoGenericMobileComponent
            route={questionRoute}
            image={'HippoHandsDown'}
            title={'Love your money, love some savings'}
            buttonColor={'green'}
            color={'blue'}
            buttonText={'View banking fees guide'}
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <FourBlogCardsComponent
            data={fourBlogCardsData}
            tag="debt-counselling"
          />
        ) : (
          <FourBlogCardsMobileComponent
            data={fourBlogCardsData}
            tag="debt-counselling"
          />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <AccordionFAQComponent data={accordionFAQData} />
        ) : (
          <AccordionFAQMobileComponent data={accordionFAQData} />
        )}
      </ScrollFadeWrapper>

      <ScrollFadeWrapper>
        {isMobile.isDesktop ? (
          <ScrollingCardsComponent data={scrollingCardsDataAll} />
        ) : (
          <ScrollingCardsMobileComponent data={scrollingCardsDataAll} />
        )}
      </ScrollFadeWrapper>
    </PageShell>
  );
}

export default DebtCounsellingPage;
